
import { TravelCard } from "../../../components/locations/TravelCard";
import { RajasthanImages } from "../../../media/rajasthan/RajasthanImages";
import PackCard from "../../../components/locations/PackCard";
import contactimg from "../../../media/contactus.png";
import { Link } from "react-router-dom";
import '../MukhaFall/MukhaFall.css';
import { BookSection } from "../../../components/BookSection";


export const Varanasi=()=>{
    return (
       <div className="mukha-fall-container">
         <div className="fancy-heading">
           <h1>Varanasi - Kashi </h1>
           <p className="sub-heading">Discover the Timeless Beauty of Varanasi: The Spiritual Heart of India</p>
         </div>
         <div className="description">
           

Varanasi, one of the oldest continuously inhabited cities in the world, is a mesmerizing blend of spirituality, history, and culture. Nestled along the sacred banks of the Ganges River in Uttar Pradesh, this ancient city has been a center of Hindu devotion, learning, and trade for over 3,000 years. Also known as Kashi or Banaras, Varanasi is believed to be the abode of Lord Shiva, making it one of the holiest pilgrimage destinations in India. The city’s spiritual essence is best experienced at the ghats, where devotees perform rituals, take holy dips, and witness the famous Ganga Aarti at Dashashwamedh Ghat, an awe-inspiring spectacle of fire, chants, and devotion. Varanasi is also home to the revered Kashi Vishwanath Temple, one of the twelve Jyotirlingas dedicated to Lord Shiva. History enthusiasts can explore the grandeur of Ramnagar Fort, a Mughal-era fort and palace showcasing vintage artifacts, royal collections, and breathtaking views of the river. Sarnath, located just a few kilometers away, is a significant Buddhist site where Lord Buddha delivered his first sermon after attaining enlightenment. The city’s rich tapestry extends beyond its spiritual significance, as Varanasi is also renowned for its vibrant silk-weaving industry, traditional street food, and bustling markets offering exquisite Banarasi sarees, handcrafted jewelry, and brassware. Whether you seek divine blessings, historical insights, or an immersive cultural experience, Varanasi promises a journey like no other, where every corner resonates with the echoes of centuries-old traditions and timeless mysticism.
  </div>
         <div className="image-gallery">
           <div className="image-item">
             <img
               src={require('../../../media/tourism/other/Varanasi/1-3-2048x1306 (1).jpg')}
               alt="Mukha Fall 1"
               className="gallery-image"
             />
             {/* <p className="image-caption">The mesmerizing first view of Mukha Fall.</p> */}
           </div>

           <div className="image-item">
             <img
                  src={require('../../../media/tourism/other/Varanasi/1-4.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
                  src={require('../../../media/tourism/other/Varanasi/107570888.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
                  src={require('../../../media/tourism/other/Varanasi/119962582_2745838612403092_451476233295116927_n.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
                  src={require('../../../media/tourism/other/Varanasi/FygFlyIXoAEhb4d.jpeg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
                 src={require('../../../media/tourism/other/Varanasi/GdnY2MlboAEAOxS.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
                 src={require('../../../media/tourism/other/Varanasi/banner-varanasi-2x.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
                 src={require('../../../media/tourism/other/Varanasi/kashmandir.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
                 src={require('../../../media/tourism/other/Varanasi/pexels-cameramanbhaiya-582256769-22485228.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
                 src={require('../../../media/tourism/other/Varanasi/pexels-chinta-pavan-kumar-2768333-4423905.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
                 src={require('../../../media/tourism/other/Varanasi/pexels-k-s-anand-456997178-16781572.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
                 src={require('../../../media/tourism/other/Varanasi/pexels-rachel-claire-8112554.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
                 src={require('../../../media/tourism/other/Varanasi/pexels-triloki-singh-189549503-11353475.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
                 src={require('../../../media/tourism/other/Varanasi/sarnath-varanasi-e1693918484606.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           
          
         </div>
   
         <BookSection />
       </div>
     );
};